module.exports = "/_next/static/images/9888f269dd2710c88e094a000152a75b-bubble-gum-woman-square@lg-1x.jpg";